module.exports = __webpack_public_path__ + "img/SSLogo.51050bd3.png";